import { normalize } from 'normalizr';
import { createAction } from 'redux-actions';
import apiResourceBuilder from '../apiResourceBuilder';
import CurrentUserActions, {
  getCurrentUser,
} from '../../../redux-modules/current-user';

const AuthorizationHeaderKey = 'AuthorizationToken';
const ENTITY_TYPE = 'ENTITY';
const createActionType = (...type) => `${ENTITY_TYPE}/${type.join('_')}`;

export const ActionTypes = {
  NORMALIZE: createActionType(ENTITY_TYPE, 'NORMALIZE'),
  GET: createActionType(ENTITY_TYPE, 'GET'),
  PUT: createActionType(ENTITY_TYPE, 'PUT'),
  POST: createActionType(ENTITY_TYPE, 'POST'),
  DELETE: createActionType(ENTITY_TYPE, 'DELETE'),
};

export const entityActionChecker = (
  type,
  namespace,
  { isNext = false } = {}
) => action => {
  return (
    action.type === type &&
    action.meta.namespace === namespace &&
    (!isNext || (action.sequence && action.sequence.type === 'next'))
  );
};

export default options => {
  if (typeof options !== 'object') {
    throw new TypeError(
      `Unsupported argument: expected object; received ${typeof options}`
    );
  }
  const {
    schema,
    api: resourceApi = apiResourceBuilder(schema.key),
    normalizedDataResolver,
  } = options;

  const handleTokens = ({ json, resp }) => dispatch => {
    if (resp) {
      if (resp.status === 401) {
        if (/TokenExpired/.test(json.message)) {
          return dispatch(CurrentUserActions.clearAuth());
        }
      }
      if (resp.headers && resp.headers.has(AuthorizationHeaderKey)) {
        const token = resp.headers.get(AuthorizationHeaderKey);
        // if it passed back more than once it is parsed as an array, that is invalid for us don't use it
        if (!Array.isArray(token) && token !== '') {
          return dispatch(CurrentUserActions.updateAuth(token));
        }
      }
    }
  };

  const defaultNormalizedDataResolver = data => {
    if (Array.isArray(data)) {
      return data;
    }
    if (data.items) {
      return data.items;
    }
    return data;
  };

  const normalizeResponse = json => {
    const data = typeof normalizedDataResolver === 'function'
      ? normalizedDataResolver(json)
      : defaultNormalizedDataResolver(json);
    return normalize(data, Array.isArray(data) ? [schema] : schema);
  };

  const normalizeAction = ({ resp, json }) => dispatch => {
    if (resp.ok && json && typeof json === 'object') {
      return dispatch(
        createAction(ActionTypes.NORMALIZE, normalizeResponse)(json)
      );
    }
  };

  const metaCreator = () => ({ schema, namespace: schema.key });

  const exec = actionType => (data, options) => (dispatch, getState) => {
    const state = getState();
    const currentUser = getCurrentUser(state);
    const defaultHeaders = currentUser && currentUser.token
      ? { [AuthorizationHeaderKey]: currentUser.token }
      : {};
    const headers = Object.assign({}, defaultHeaders, (options || {}).headers);

    const apiCall = () => {
      const method = resourceApi[actionType];
      return method(data, {
        ...options,
        headers,
      }).then(results => {
        //only update the token with one from the server if you currently have one on state
        const newState = getState();
        if ((getCurrentUser(newState) || {}).token) {
          dispatch(handleTokens(results));
        }
        // todo: check perf, if this is taking any time at all remove and move normalize to reducer
        dispatch(normalizeAction(results));
        return results;
      });
    };

    return dispatch(
      createAction(
        ActionTypes[actionType.toUpperCase()],
        apiCall,
        metaCreator
      )()
    );
  };

  return {
    options: {
      schema,
      resourceApi,
    },
    get: exec('get'),
    post: exec('post'),
    put: exec('put'),
    delete: exec('delete'),
  };
};



// WEBPACK FOOTER //
// ./src/common/utils/entityActionCreator/index.js